<script lang="ts">
	import { Responsive } from "responsive"
	import type { Snippet } from "svelte"

	interface Props {
		title: string
		description: string
		stepNumber: number
		isActive: boolean
		content: Snippet
	}

	let { title, description, stepNumber, isActive, content }: Props = $props()
</script>

<div class="step" class:active={isActive} class:mobile={Responsive.isMobile}>
	<div class="step-button">
		<span class="step-number">{stepNumber}</span>
		<span class="step-text">
			<h3>{title}</h3>
			<span class="step-description">{description}</span>
		</span>
	</div>
	<div class="step-content" class:hidden={!isActive}>
		{#if isActive}
			{@render content()}
		{/if}
	</div>
</div>

<style>
	.step {
		display: flex;
		flex-direction: column;
		width: 100%;
		overflow: hidden;
		min-height: 4rem;
	}

	.step:not(:first-of-type) {
		margin-top: 1rem;
	}

	.mobile.step {
		min-height: 3rem;
	}

	.step.active {
		flex-grow: 1;
	}

	h3 {
		margin: 0;
		color: var(--color-text-light);
		font-size: var(--h1);
		transition:
			font-size 250ms,
			color 500ms;
	}

	.mobile h3 {
		font-size: var(--h2);
	}

	.step.active h3 {
		color: var(--color-main);
	}

	.step-description {
		transition:
			font-size 250ms,
			color 500ms;
	}

	.step-button {
		margin-bottom: 0.5rem;
		display: flex;
		flex-direction: row;
		color: var(--color-text);
		align-items: center;
		min-height: 4rem;
	}

	.mobile .step-button {
		min-height: 3rem;
	}

	.step-content {
		margin-left: 4rem;
		min-height: 0;
		margin-bottom: 1rem;
		overflow: hidden;
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.mobile .step-content {
		margin: 0 0.5rem;
	}

	.step-content.hidden {
		display: none;
	}

	.step-content:global(:has(.show-selector)) {
		margin-left: unset;
	}

	.step-number {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 3rem;
		height: 3rem;
		border: 1px solid var(--color-text);
		color: var(--color-text-light);

		border-radius: 99px;
		margin-right: 1rem;
		padding-bottom: 0.5rem;
		font-size: 2rem;
	}

	.mobile .step-number {
		width: 2.5rem;
		height: 2.5rem;
		/* font-size:; */
	}

	.step-text {
		position: relative;
		font-size: var(--h2);
		padding-right: 3rem;
		max-width: calc(100% - 4rem);

		line-height: 1em;
	}

	.mobile .step-text {
		padding-right: 0;
		max-width: calc(100% - 4rem);
	}
</style>
